import React, { useState } from "react";
import "./index.css";
import SearchFilter from "../../../components/Portfolio/SearchFilter";
// import unassignedTableData from '../../../constant/unassignedTable';
import Table from "../../../components/Common/Table";
import Pagination from "../../../components/Pagination";
import Button from "../../../components/Common/Button";
import { productType } from "../../../constant/selectOptions";
import { eligibleForLender } from "../../../constant/selectOptions";
import { productName } from "../../../constant/selectOptions";
import PortfolioContainer from "../../../components/Portfolio/PortfolioContainer";
import LenderUgroService from "../../../services/lender";
import { Context } from "../../../config/store";
import TableNoRecords from "../../../components/Common/Table/TableNoRecords";
import portfolio from "../../../constant/tableHeaders/portfolio";
import { downloadFile } from "../../../common/download";
import objectToQueryParams from '../../../common/objectToQueryParams';

function ApprovedPortfolio({ leadType, path }) {
  let sessionStorageData = JSON.parse(sessionStorage.getItem('searchData')) || {};
  let { org_page = 1 } = sessionStorageData;
  const queryString = objectToQueryParams(sessionStorageData);
  const [queryParams, setQueryParams] = React.useState(queryString);
  const [tableData, setTableData] = useState({
    columns: portfolio,
    rows: [],
  });
  const [page, setCurrentPage] = useState(org_page);
  const [loading, setLoading] = React.useState(true);
  const [pagination, setPagination] = useState({});
  const { state, dispatch } = React.useContext(Context);
  const [sortParams, setSortParams] = React.useState({
    sortBy: "",
    sortOrder: "",
  });
  const [excelLoader, setExcelLoader] = useState(false)
  const showStatusFilter = () =>
    leadType.includes("disbursal") ? false : true;
  const getPortfolio = async (paramsChanged, sortBy, sortOrder) => {
    setLoading(true);
    const response = await LenderUgroService.getFilteredPortfolio({
      type: state.userType,
      leadType,
      page: paramsChanged ? 1 : page,
      dataExport: 0,
      sortBy: sortBy ? sortBy : sortParams.sortBy,
      sortOrder: sortOrder ? sortOrder : sortParams.sortOrder,

      queryParams,
    });
    const data = response.data.data?.cl_leads;
    setTableData({
      ...tableData,
      rows: data?.data || [],
    });

    setCurrentPage(page);
    // Update session storage data if page changed
    let searchDataNew = {...sessionStorageData, org_page: (paramsChanged ? 1 : page)}
    sessionStorage.setItem('searchData', JSON.stringify(searchDataNew))
    setPagination(response?.data?.data.cl_leads.pagination);
    setLoading(false);
  };
  const onSortChange = ({ sortOrder, sortBy }) => {
    setSortParams({ sortBy, sortOrder });
    getPortfolio(false, sortOrder, sortBy);
  };
  const exportLead = async () => {
    setExcelLoader(true)
    const response = await LenderUgroService.getFilteredPortfolio({
      type: state.userType,
      leadType,
      page,
      dataExport: 1,
      queryParams,
      sortBy: sortParams.sortBy,
      sortOrder: sortParams.sortOrder,
      responseType: "blob",
    });
    let fileName = ''
    if (leadType === 'approve') {
      fileName = 'Sanctioned-portfolio'
    } else if (leadType === 'disbursal-pending') {
      fileName = 'Disbursal-pending'
    } else if (leadType === 'disbursal-approved') {
      fileName = 'Disbursed-portfolio'
    } else if (leadType === 'disbursal-rejected') {
      fileName = 'Disbursal-rejected'
    }
    downloadFile(response.data, fileName + +new Date());
    setExcelLoader(false)
  };

  React.useEffect(() => {
    getPortfolio();
  }, [page, path]);

  React.useEffect(() => {
    if (!loading) getPortfolio(true);
  }, [queryParams]);
  React.useEffect(() => {
    dispatch({
      type: "selectedColender",
      selectedColender: path,
    });
    localStorage.setItem("selectedColender", path);
  }, [path]);

  return (
    <PortfolioContainer>
      <SearchFilter
        setQueryParams={setQueryParams}
        productTypes={productType}
        productNames={productName}
        lenders={eligibleForLender}
        statusOptions={
          showStatusFilter() && [
            { label: "Approved", value: "6,7" },
            { label: "Pull Back", value: 8 },
          ]
        }
        loading={loading}
      ></SearchFilter>
      <div className="d-flex justify-content-end">
        {excelLoader ? <Button classNames='excelDownloadLoader my-3'> <div className="loader"></div></Button> :
          <Button
            type='btn-export'
            classNames='float-right mt-3 mb-3'
            clickHandler={exportLead}
          >
            	<i class="fa fa-file-excel-o mr-1" aria-hidden="true"></i>
            Export Excel
          </Button>
        }
      </div>
      <div className="post_disbursal_case">
        <Table
          checkbox={false}
          columns={tableData.columns.filter(
            ({ field }) => field !== "lender_name"
          )}
          rows={tableData.rows}
          type="approved"
          onSortChange={onSortChange}
          loading={loading}
          reloadTable={getPortfolio}
        >
          {Boolean(!tableData.rows.length && !loading) && <TableNoRecords />}
        </Table>
      </div>

      {pagination?.total_pages ? (
        <Pagination
          disabled={loading}
          setPage={setCurrentPage}
          total_pages={pagination.total_pages}
          total={pagination.total}
          showTotal={true}
        />
      ) : (
        ""
      )}
    </PortfolioContainer>
  );
}

export default ApprovedPortfolio;
